import { render, staticRenderFns } from "./induction_confirm.vue?vue&type=template&id=f4f59770&scoped=true&"
import script from "./induction_confirm.vue?vue&type=script&lang=js&"
export * from "./induction_confirm.vue?vue&type=script&lang=js&"
import style0 from "./induction_confirm.vue?vue&type=style&index=0&id=f4f59770&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f59770",
  null
  
)

export default component.exports